import React from "react";
import { Alert, Box, Chip, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../router/routes";

export const DeletePanel: React.FC<{ children?: JSX.Element, message: string, errorMessage?: string, errorData?: any }> = (props) => {
    return (
        <Box>
            <Typography variant={"body1"} gutterBottom color={"GrayText"}>{props.message}</Typography>

            {props.errorMessage && <Alert severity="error" >
                {props.errorMessage}
                {props.errorData && <Box>
                    <Typography variant="caption" sx={{
                        mt: 1
                    }}>
                        {"Because of the below dependencies"}
                    </Typography>
                    {props.errorData.nouns && props.errorData.nouns.length > 0 && <Stack direction={"row"} spacing={1} sx={{
                        mt: 1
                    }}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>Nouns: </Typography>
                        <Typography variant="subtitle2">{props.errorData.nouns.map((_: any) => _.noun_name).join(", ")}</Typography>
                    </Stack>}
                    {props.errorData.attributes && props.errorData.attributes.length > 0 && <Stack direction={"row"} spacing={1} sx={{
                        mt: 1
                    }}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>Attributes: </Typography>
                        <Typography variant="subtitle2">{props.errorData.attributes.map((_: any) => _.attr_name).join(", ")}</Typography>
                    </Stack>}
                    {props.errorData.noun_variants && props.errorData.noun_variants.length > 0 && <Stack direction={"row"} spacing={1} sx={{
                        mt: 1
                    }}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>Noun Variants: </Typography>
                        <Typography variant="subtitle2">{props.errorData.noun_variants.map((_: any) => _.nounvariant_name).join(", ")}</Typography>
                    </Stack>}

                    {props.errorData.materials && props.errorData.materials.length > 0 && <Stack
                        direction={"row"}
                        spacing={1}
                        sx={{
                            alignItems: "flex-start",
                            mt: 1
                        }}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>Materials: </Typography>
                        <Stack
                            direction={"row"}
                            sx={{
                                alignItems: 'flex-start',
                                gap: 1,
                                flexWrap: "wrap"
                            }}>
                            {
                                props.errorData.materials.map((_: any, index: number) => (
                                    <Link target="_blank" to={AppRoutes.viewMatBasicDetail(_?._id)}>
                                        <Chip
                                            sx={{ height: "16px", fontSize: "12px", cursor: "pointer" }}
                                            key={index}
                                            size='small'
                                            variant={'outlined'}
                                            label={`${_?.sequence_id ?? ""}-r${_?.version ?? ""}`}
                                        />
                                    </Link>
                                ))
                            }
                        </Stack>
                    </Stack>}

                    {props.errorData?.boms && props.errorData?.boms?.length > 0 && <Stack
                        direction={"row"}
                        spacing={1}
                        sx={{
                            alignItems: "flex-start",
                            mt: 1
                        }}>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>BOMs: </Typography>
                        <Stack
                            direction={"row"}
                            sx={{
                                alignItems: 'flex-start',
                                gap: 1,
                                flexWrap: "wrap"
                            }}>
                            {
                                props.errorData.boms.map((_: any, index: number) => (
                                    <Link target="_blank" to={AppRoutes.viewBomBasicDetail(_?._id)}>
                                        <Chip
                                            sx={{ height: "16px", fontSize: "12px", cursor: "pointer" }}
                                            key={index}
                                            size='small'
                                            variant={'outlined'}
                                            label={`${_?.sequence_id ?? ""}-r${_?.version ?? ""}`}
                                        />
                                    </Link>
                                ))
                            }
                        </Stack>
                    </Stack>}

                </Box>}
            </Alert>}
        </Box>
    );
}